var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.b(),style:(_vm.styleSizeName)},[_c('div',{staticClass:"swiper-container"},[(_vm.reload)?_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2):_vm._e(),_c('div',{staticClass:"swiper-pagination"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }